/* import __COLOCATED_TEMPLATE__ from './listbox.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { guidFor } from '@ember/object/internals';
import { debounce } from '@ember/runloop';
const ACTIVATE_NONE = 0;
const ACTIVATE_FIRST = 1;
const ACTIVATE_LAST = 2;
const PREVENTED_KEYDOWN_EVENTS = new Set(['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'PageUp', 'PageDown', 'Home', 'End']);
let ListboxComponent = (_class = class ListboxComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "activeOptionIndex", _descriptor, this);
    _defineProperty(this, "activateBehaviour", ACTIVATE_NONE);
    _defineProperty(this, "buttonElement", void 0);
    _defineProperty(this, "guid", `${guidFor(this)}-headlessui-listbox`);
    _initializerDefineProperty(this, "_isOpen", _descriptor2, this);
    _defineProperty(this, "labelElement", void 0);
    _defineProperty(this, "optionsElement", void 0);
    _defineProperty(this, "optionElements", []);
    _defineProperty(this, "optionValues", {});
    _defineProperty(this, "search", '');
    _initializerDefineProperty(this, "selectedOptionIndex", _descriptor3, this);
  }
  get activeOptionGuid() {
    return this.optionElements[this.activeOptionIndex]?.id;
  }
  get isDisabled() {
    return !!this.args.disabled;
  }
  get selectedOptionGuid() {
    return this.optionElements[this.selectedOptionIndex]?.id;
  }
  get isOpen() {
    return this._isOpen;
  }
  set isOpen(isOpen) {
    if (isOpen) {
      this.activeOptionIndex = undefined;
      this.selectedOptionIndex = undefined;
      this.optionElements = [];
      this.optionValues = {};
      this._isOpen = true;
    } else {
      this._isOpen = false;
    }
  }
  closeListbox() {
    this.isOpen = false;
  }
  handleButtonClick(e) {
    if (e.button !== 0) return;
    this.activateBehaviour = ACTIVATE_NONE;
    this.isOpen = !this.isOpen;
  }
  handleClickOutside(e) {
    let isClickOutsideButton = !e.srcElement.closest(`#${this.buttonElement.id}`);
    if (isClickOutsideButton) {
      this.closeListbox();
    }
    return true;
  }
  handleKeyDown(event) {
    if (PREVENTED_KEYDOWN_EVENTS.has(event.key)) {
      event.preventDefault();
    }
  }
  handleKeyUp(event) {
    if (event.key === 'ArrowDown') {
      if (!this.isOpen) {
        this.activateBehaviour = ACTIVATE_FIRST;
        this.isOpen = true;
      } else {
        this.setNextOptionActive();
      }
    } else if (event.key === 'ArrowRight') {
      if (this.isOpen) {
        this.setNextOptionActive();
      }
    } else if (event.key === 'ArrowUp') {
      if (!this.isOpen) {
        this.activateBehaviour = ACTIVATE_LAST;
        this.isOpen = true;
      } else {
        this.setPreviousOptionActive();
      }
    } else if (event.key === 'ArrowLeft') {
      if (this.isOpen) {
        this.setPreviousOptionActive();
      }
    } else if (event.key === 'Home' || event.key === 'PageUp') {
      this.setFirstOptionActive();
    } else if (event.key === 'End' || event.key === 'PageDown') {
      this.setLastOptionActive();
    } else if (event.key === 'Escape') {
      this.isOpen = false;
    }
  }
  handleKeyPress(event) {
    if (event.key === 'Enter' || (event.key === 'Space' || event.key === ' ') && this.search === '') {
      this.activateBehaviour = ACTIVATE_FIRST;
      if (this.isOpen) {
        this.setSelectedOption(event.target, event);
        this.isOpen = false;
      } else {
        this.isOpen = true;
      }
      event.preventDefault();
      event.stopPropagation();
    } else if (event.key.length === 1) {
      this.addSearchCharacter(event.key);
    }
  }
  handleLabelClick(e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.ctrlKey || e.button !== 0) return;
    this.buttonElement.focus();
  }
  openListbox() {
    this.isOpen = true;
  }
  registerButtonElement(buttonElement) {
    this.buttonElement = buttonElement;
  }
  unregisterButtonElement() {
    this.buttonElement = undefined;
  }
  registerLabelElement(labelElement) {
    this.labelElement = labelElement;
  }
  registerOptionElement(optionComponent, optionElement) {
    this.optionElements.push(optionElement);
    this.optionValues[optionComponent.guid] = optionComponent.args.value;

    // store the index at which the option appears in the list
    // so we can avoid a O(n) find operation later
    optionComponent.index = this.optionElements.length - 1;
    optionElement.setAttribute('data-index', this.optionElements.length - 1);
    if (this.args.value) {
      if (this.args.value === optionComponent.args.value) {
        this.selectedOptionIndex = this.activeOptionIndex = this.optionElements.length - 1;
      }
    }
    if (!this.selectedOptionIndex) {
      switch (this.activateBehaviour) {
        case ACTIVATE_FIRST:
          this.setFirstOptionActive();
          break;
        case ACTIVATE_LAST:
          this.setLastOptionActive();
          break;
      }
    }
  }
  registerOptionsElement(optionsElement) {
    this.optionsElement = optionsElement;
  }
  unregisterOptionsElement() {
    this.optionsElement = undefined;
  }
  setActiveOption(optionComponent) {
    this.optionElements.forEach((o, i) => {
      if (o.id === optionComponent.guid && !o.hasAttribute('disabled')) {
        this.activeOptionIndex = i;
        document.querySelector('#' + optionComponent.guid).focus();
      }
    });
  }
  setSelectedOption(optionComponent, e) {
    let optionIndex, optionValue;
    if (optionComponent.constructor.name === 'ListboxOptionComponent') {
      optionValue = optionComponent.args.value;
      optionIndex = optionComponent.index;
    } else if (this.activeOptionIndex !== undefined) {
      optionValue = this.optionValues[this.optionElements[this.activeOptionIndex].id];
      optionIndex = parseInt(this.optionElements[this.activeOptionIndex].getAttribute('data-index'));
    } else {
      return;
    }
    if (!this.optionElements[optionIndex].hasAttribute('disabled')) {
      this.selectedOptionIndex = optionIndex;
      if (this.args.onChange) {
        this.args.onChange(optionValue);
      }
      if (e.type === 'click') {
        this.isOpen = false;
      }
    } else {
      this.optionsElement.focus();
    }
  }
  scrollIntoView(optionElement) {
    // Cannot use optionElement.scrollIntoView() here because that function
    // also scrolls the *window* by some amount. Here, we don't want to
    // jerk the window, we just want to make the the option element visible
    // inside its container.

    optionElement.parentElement.scroll(0, optionElement.offsetTop - optionElement.parentElement.offsetTop);
  }
  unsetActiveOption() {
    this.activeOptionIndex = undefined;
  }
  setNextOptionActive() {
    for (let i = this.activeOptionIndex + 1; i < this.optionElements.length; i++) {
      if (!this.optionElements[i].hasAttribute('disabled')) {
        this.activeOptionIndex = i;
        break;
      }
    }
  }
  setPreviousOptionActive() {
    for (let i = this.activeOptionIndex - 1; i >= 0; i--) {
      if (!this.optionElements[i].hasAttribute('disabled')) {
        this.activeOptionIndex = i;
        break;
      }
    }
  }
  setFirstOptionActive() {
    for (let i = 0; i < this.optionElements.length; i++) {
      if (!this.optionElements[i].hasAttribute('disabled')) {
        this.activeOptionIndex = i;
        break;
      }
    }
  }
  setLastOptionActive() {
    for (let i = this.optionElements.length - 1; i >= 0; i--) {
      if (!this.optionElements[i].hasAttribute('disabled')) {
        this.activeOptionIndex = i;
        break;
      }
    }
  }
  clearSearch() {
    this.search = '';
  }
  addSearchCharacter(key) {
    debounce(this, this.clearSearch, 500);
    this.search += key.toLowerCase();
    for (let i = 0; i < this.optionElements.length; i++) {
      let optionElement = this.optionElements[i];
      if (!optionElement.hasAttribute('disabled') && optionElement.textContent.trim().toLowerCase().startsWith(this.search)) {
        this.scrollIntoView(optionElement);
        this.activeOptionIndex = i;
        break;
      }
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "activeOptionIndex", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_isOpen", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.args.isOpen || false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "selectedOptionIndex", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "closeListbox", [action], Object.getOwnPropertyDescriptor(_class.prototype, "closeListbox"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleButtonClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleButtonClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleClickOutside", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleClickOutside"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleKeyDown", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleKeyDown"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleKeyUp", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleKeyUp"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleKeyPress", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleKeyPress"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleLabelClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleLabelClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openListbox", [action], Object.getOwnPropertyDescriptor(_class.prototype, "openListbox"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "registerButtonElement", [action], Object.getOwnPropertyDescriptor(_class.prototype, "registerButtonElement"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "unregisterButtonElement", [action], Object.getOwnPropertyDescriptor(_class.prototype, "unregisterButtonElement"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "registerLabelElement", [action], Object.getOwnPropertyDescriptor(_class.prototype, "registerLabelElement"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "registerOptionElement", [action], Object.getOwnPropertyDescriptor(_class.prototype, "registerOptionElement"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "registerOptionsElement", [action], Object.getOwnPropertyDescriptor(_class.prototype, "registerOptionsElement"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "unregisterOptionsElement", [action], Object.getOwnPropertyDescriptor(_class.prototype, "unregisterOptionsElement"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setActiveOption", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setActiveOption"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setSelectedOption", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setSelectedOption"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "unsetActiveOption", [action], Object.getOwnPropertyDescriptor(_class.prototype, "unsetActiveOption"), _class.prototype), _class);
export { ListboxComponent as default };